/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_Contentslabel1Inputs */

const ja_playdata_pricing_contentslabel1 = /** @type {(inputs: Playdata_Pricing_Contentslabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レポートに含まれるもの`)
};

const en_playdata_pricing_contentslabel1 = /** @type {(inputs: Playdata_Pricing_Contentslabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report Contents`)
};

/**
* | output |
* | --- |
* | "Report Contents" |
*
* @param {Playdata_Pricing_Contentslabel1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_pricing_contentslabel1 = /** @type {((inputs?: Playdata_Pricing_Contentslabel1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_Contentslabel1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_contentslabel1(inputs)
	return en_playdata_pricing_contentslabel1(inputs)
});
export { playdata_pricing_contentslabel1 as "playdata_pricing_contentsLabel" }